import { EXPORT_READ_API_PREFIX } from '@aibees/elephant/constants';
import { useBrowseSearchExports } from '@aibees/elephant/hooks/use-browse-search-exports';
import { HttpMethod } from '@aibees/shared/definition';
import { baseQueryClient, useBaseMutation } from '@aibees/shared/http';
import { useWorkspace } from '@aibees/shared/workspace';
import { UpdateExportRequest } from './types';

export function useUpdateExportApi(id: string) {
  const workspaceId = useWorkspace()?.id ?? '';

  return useBaseMutation<UpdateExportRequest, unknown>(
    {
      url: `${EXPORT_READ_API_PREFIX.replace(':wid', workspaceId).replace(
        ':id',
        id
      )}`,
      method: HttpMethod.patch,
    },
    {
      onSuccess: () => {
        baseQueryClient.invalidateQueries([useBrowseSearchExports.name]);
      },
    }
  );
}
